export default "__VITE_ASSET__3G2kSRU8__"